import React from 'react';

const ServiceServing = ({ title, subtitle, cities, footerText }) => {
    const defaultCities = [
        "Los Angeles",
        "San Diego",
        "San Francisco",
        "Sacramento",
        "San Jose",
        "Fresno",
        "Oakland",
        "Long Beach",
        "Anaheim",
        "Irvine"
    ];

    const displayCities = cities || defaultCities;

    return (
        <section className="service-serving-section">
            <div className="service-serving-container">
                <div className="service-serving-header">
                    <h2 className="service-serving-title">
                        {title || (
                            <>
                                <span className="text-primary">Serving Projects</span> Across California
                            </>
                        )}
                    </h2>
                    <p className="service-serving-subtitle">
                        {subtitle || "We proudly offer Scan to BIM services throughout California, including major cities and surrounding regions such as:"}
                    </p>
                </div>

                <div className="serving-grid">
                    {displayCities.map((city, index) => (
                        <div key={index} className="serving-tag">
                            {city}
                        </div>
                    ))}
                </div>

                <p className="service-serving-footer">
                    {footerText || "We will use the same accuracy and professionalism wherever your project is located."}
                </p>
            </div>
        </section>
    );
};

export default ServiceServing;
